import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, InputGroup, ButtonToolbar } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import TagsInput from 'react-tagsinput';
import moment from 'moment';

import DropdownMaakunta from './DropdownMaakunta.jsx';
import DropdownLaajuus from './DropdownLaajuus.jsx';

import { filterStartDate, filterEndDate, filterTagSearch } from '../../reducers/filter';
import keyCodes from '../../keyCodes';

import '../css/react-datepicker-modified.css';
import '../css/react-tagsinput-modified.css';
import '../css/EventFilter.css';

class EventFilter extends Component {
  constructor() {
    super();

    const startDate = moment().startOf('month');
    const endDate = startDate.clone().add(1, 'year');

    this.state = {
      tags: [],
      inputStyle: {
        placeholder: 'Rajaa avainsanalla'
      },
      startDate,
      endDate
    };

    this.handleChangeDatePickerStart = this.handleChangeDatePickerStart.bind(this);
    this.handleChangeDatePickerEnd = this.handleChangeDatePickerEnd.bind(this);
    this.handleChangeTags = this.handleChangeTags.bind(this);
  }

  componentDidMount() {
    this.handleChangeDatePickerStart(this.state.startDate);
    this.handleChangeDatePickerEnd(this.state.endDate);
  }

  handleChangeTags(tags) {
    this.setState({ tags }, () => { this.changePlaceholder(); });
    this.props.changeFilter(filterTagSearch(tags));
  }

  changePlaceholder() {
    const newInputStyle = this.state.inputStyle;
    if (this.state.tags.length === 0) {
      newInputStyle.placeholder = 'Rajaa avainsanalla';
      this.setState({ inputStyle: newInputStyle });
    } else {
      newInputStyle.placeholder = '';
      this.setState({ inputStyle: newInputStyle });
    }
  }

  handleChangeDatePickerStart(date) {
    this.setState({ startDate: date });
    this.props.changeFilter(filterStartDate(moment(date).format('YYYY-MM-DD')));
  }

  handleChangeDatePickerEnd(date) {
    this.setState({ endDate: date });
    this.props.changeFilter(filterEndDate(moment(date).format('YYYY-MM-DD')));
  }

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <ButtonToolbar>
              <DropdownMaakunta changeFilter={this.props.changeFilter} />
              <DropdownLaajuus changeFilter={this.props.changeFilter} />
              <InputGroup>
                <TagsInput
                  inputProps={this.state.inputStyle}
                  value={this.state.tags}
                  onChange={this.handleChangeTags}
                  addKeys={[keyCodes.enter, keyCodes.space, keyCodes.tab]}
                  maxTags={5}
                  onlyUnique
                />
              </InputGroup>
              <InputGroup className="filter-datepicker">
                <DatePicker
                  className="form-control"
                  todayButton={'Tänään'}
                  selectsStart startDate={this.state.startDate}
                  selected={this.state.startDate}
                  maxDate={this.state.endDate}
                  onChange={this.handleChangeDatePickerStart}
                />
              </InputGroup>
              <InputGroup className="filter-datepicker">
                <DatePicker
                  className="form-control"
                  selectsEnd startDate={this.state.startDate}
                  selected={this.state.endDate}
                  minDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onChange={this.handleChangeDatePickerEnd}
                />
              </InputGroup>
            </ButtonToolbar>
          </Col>
        </Row>
      </div>
    );
  }
}

EventFilter.propTypes = {
  changeFilter: PropTypes.func.isRequired
};

export default EventFilter;



// WEBPACK FOOTER //
// ./src/components/eventFilter/EventFilter.jsx